import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { CurrencySignType, I18nService, LgType } from '../../../../services/prod/i18n.service'

type ParentComponentType = 'Cart popup' | 'Checkout page'

@Component({
  selector: 'bmcore-payment-bottom-block',
  templateUrl: './bmcore-payment-bottom-block.component.html',
  styleUrls: ['./bmcore-payment-bottom-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePaymentBottomBlockComponent implements OnInit {
  @Input() priceWithDiscount: number
  @Input() cashbackAmount: number
  @Input() currencySign: CurrencySignType
  @Input() parentComponent: ParentComponentType

  lg: LgType

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }
}
